import { render, staticRenderFns } from "./SendingSmsStaff.vue?vue&type=template&id=83130f02"
import script from "./SendingSmsStaff.vue?vue&type=script&lang=js"
export * from "./SendingSmsStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports